export default __webpack_public_path__ + "static/media/SackBrand.2f2e5995.jpg";